import ButtonT from "./Button";

const Controls = {
    ButtonT
}

export default Controls;